import React, { Fragment } from 'react'
import { MenuItem } from '@newageerp/ui.menu.base.menu'
import { useHistory } from 'react-router';

interface Props {
    forceSkipIcon?: boolean;
}

export default function MenuItemTablets(props: Props) {
    const history = useHistory();

    const path = '/tablets';

    const badgeKey = '';

    const goTo = () => {
        history.push(path);
    }

    return (
        <Fragment>
            <MenuItem onClick={goTo} icon={props.forceSkipIcon?'':''} badgeKey={badgeKey?badgeKey:undefined}>{'Planšetės'}</MenuItem>
        </Fragment>
    )
}
